import { Injectable } from "@angular/core";
import { User } from "src/app/domain/models/user.model";
import { constants } from "src/environments/constants";

@Injectable({
  providedIn: 'root',
})
export class SessionStorageService {
  private userSessionStorageToken = constants.USER_KEY;

  setUser(user: User) {
    sessionStorage.setItem(
      this.userSessionStorageToken,
      JSON.stringify(user)
    )
  }

  getUser(): User | undefined {
    const sessionStr = sessionStorage.getItem(this.userSessionStorageToken)
    if (sessionStr) {
      return JSON.parse(sessionStr)
    }

    return undefined
  }

  removeUser() {
    sessionStorage.removeItem(this.userSessionStorageToken)
  }
}